<template>
  <div class="ontag">
    <div class="ontag__content">
      <div>
        <span class="h1">Event</span>
        <span
          v-if="isLoading"
          class="element--is-loading"></span>
      </div>
      <template v-if="eventTodo && !isLoading">
        <template v-if="(id || handleTask) && eventTodo">
          <a @click="showNone"> &lt; Back to list </a>
          <section>
            <card :info="cardInfo" />
            <h3>Event</h3>
            <table class="eventTable">
              <thead>
                <th>Eventline</th>
                <th>Task</th>
                <th>Eventdate</th>
                <th>Event Type</th>
                <th>Currency</th>
                <th>Description</th>
                <th>Unitprice</th>
                <th>Unit of measurment</th>
                <th>Quantity</th>
                <th>Invoice amount</th>
                <th>Revenue amount</th>
              </thead>
              <tr
                v-for="(event, i) in eventTodo.events"
                v-bind:key="i">
                <td>{{ i + 1 }}</td>
                <td>{{ event.task }}</td>
                <td>{{ event.eventDateText }}</td>
                <td>{{ event.eventType }}</td>
                <td>{{ event.currency }}</td>
                <td>{{ event.description }}</td>
                <td>{{ event.unitCustomerPrice }}</td>
                <td>{{ event.unitOfMeasure }}</td>
                <td>{{ event.quantity }}</td>
                <td>{{ event.invoiceAmount }}</td>
                <td>{{ event.revenueAmount }}</td>
              </tr>
            </table>

            <p>TE order comment</p>
            <textarea
              v-if="eventTodo.teComment"
              disabled
              v-model="eventTodo.teComment"></textarea>
            <br />
            <br />
            <label>Comment (Mandatory input if Delete or Pause)</label>
            <br />
            <textarea v-model="eventTodo.comment"></textarea>
            <br />
            <p v-if="eventTodo.doneBy">Task done by: {{ eventTodo.doneBy }}</p>
            <p v-if="eventTodo.pausedBy">
              Task paused by: {{ eventTodo.pausedBy }}
            </p>
            <p v-if="eventTodo.deletedBy">
              Task deleted by: {{ eventTodo.deletedBy }}
            </p>
            <p v-if="eventTodo.cancelled">Task cancelled</p>
            <template v-if="eventTodo.externalId">
              <div class="input-group--inline">
                <a @click="showNone"> &lt; Previous </a>
                <base-button
                  class="button--background-gray-dark"
                  @click="showNone"
                  text="Cancel">
                </base-button>
                <base-button
                  class="button--background-red"
                  :disabled="setDisabledPauseButton()"
                  @click="setAsPause()"
                  :text="
                    'Pause' +
                    (index < eventTodos.length - 1 && handleTask
                      ? ' and next'
                      : '')
                  ">
                </base-button>
                <base-button
                  class="button--background-red"
                  :disabled="setDisabledDeleteButton()"
                  @click="setAsDelete()"
                  :text="
                    'Delete' +
                    (index < eventTodos.length - 1 && handleTask
                      ? ' and next'
                      : '')
                  ">
                </base-button>
                <base-button
                  class="button--background-blue"
                  :disabled="setDisabledDoneButton()"
                  @click="setAsDone()"
                  :text="
                    'Done' +
                    (index < eventTodos.length - 1 && handleTask
                      ? ' and next'
                      : '')
                  ">
                </base-button>
              </div>
            </template>
          </section>
        </template>
        <template v-else-if="eventTodos && !isLoading">
          <section class="todos_top-container">
            <input
              type="text"
              placeholder="Search"
              v-model="searchQuery" />
            <base-button
              :disabled="isLoading"
              text="Handle tasks"
              @click="handleTasks(0)">
            </base-button>
            <card :info="totalCardInfo" />
            <div class="todos_top-container__showShipped">
              <input
                type="checkbox"
                id="showShipped"
                v-model="showShipped" />
              <label for="showShipped">{{ $t('showOnlyShipped') }}</label>
            </div>
          </section>
          <table>
            <thead>
              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Status"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'status')"
                  :options="filterValues('status')">
                </multi-select>
              </th>

              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Projectnumber"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'terpId')"
                  :options="filterValues('terpId')">
                </multi-select>
              </th>

              <th>Customer</th>
              <th>Club name</th>
              <th>Order no.</th>
              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Revenue month"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'revenueMonth')"
                  :options="filterValues('revenueMonth')">
                </multi-select>
              </th>
              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Revenue year"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'revenueYear')"
                  :options="filterValues('revenueYear')">
                </multi-select>
              </th>
              <th>Revenue</th>
              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Cost month"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'costMonth')"
                  :options="filterValues('costMonth')">
                </multi-select>
              </th>
              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Cost year"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'costYear')"
                  :options="filterValues('costYear')">
                </multi-select>
              </th>
              <th>Cost</th>
              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Delivery week"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'deliveryWeek')"
                  :options="filterValues('deliveryWeek')">
                </multi-select>
              </th>
              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Last update"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'lastChanged')"
                  :options="filterValues('lastChanged')">
                </multi-select>
              </th>
              <th></th>
            </thead>
            <tr
              v-for="(eventTodo, i) in eventTodos"
              v-bind:key="i">
              <td>{{ eventTodo.status }}</td>
              <td>{{ eventTodo.terpId }}</td>
              <td>{{ eventTodo.customer }}</td>
              <td>{{ eventTodo.clubName }}</td>
              <td>{{ eventTodo.orderNumber }}</td>
              <td>{{ eventTodo.revenueMonth }}</td>
              <td>{{ eventTodo.revenueYear }}</td>
              <td>{{ eventTodo.revenue }}</td>
              <td>{{ eventTodo.costMonth }}</td>
              <td>{{ eventTodo.costYear }}</td>
              <td>{{ eventTodo.cost }}</td>
              <td>{{ eventTodo.deliveryWeek }}</td>
              <td>
                {{
                  eventTodo.lastChanged == '' || eventTodo.lastChangedBy == ''
                    ? ''
                    : eventTodo.lastChanged + ' by ' + eventTodo.lastChangedBy
                }}
              </td>
              <td @click="handleEventTodo(eventTodo.externalId, i)">
                <use-svg
                  svg="arrow-right"
                  class="svg--90-negative" />
              </td>
            </tr>
          </table>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/form-elements/base-button';
import MultiSelect from '@/components/form-elements/multi-select';
import UseSvg from '@/components/use-svg';
import Card from '@/components/info/card';

export default {
  name: 'Event',
  components: {
    BaseButton,
    MultiSelect,
    UseSvg,
    Card,
  },
  props: {
    id: {
      type: String,
    },
  },
  data() {
    return {
      isLoading: true,
      index: 0,
      filter: {
        status: ['Paused', 'To do'],
        terpId: [],
        revenueMonth: [],
        revenueYear: [],
        costMonth: [],
        costYear: [],
        deliveryWeek: [],
        lastChanged: [],
      },
      sortBy: 'changedDate',
      handleTask: false,
      showShipped: false,
      searchQuery: '',
    };
  },
  watch: {
    id: {
      immediate: true,
      handler(newId) {
        if (newId) {
          this.$store.dispatch('todo/getCostTodo', { id: newId });
        } else {
          this.showNone();
        }
      },
    },
  },
  computed: {
    _eventTodos() {
      return this.$store.getters['todo/costTodos'];
    },
    cardInfo() {
      return [
        { id: 1, label: 'Status:', value: this.eventTodo.status },
        { id: 2, label: 'Order no.:', value: this.eventTodo.orderNumber },
        { id: 3, label: 'Customer in TERP:', value: this.eventTodo.customer },
        { id: 4, label: 'Club name:', value: this.eventTodo.clubName },
        { id: 5, label: 'Project no. in TERP:', value: this.eventTodo.terpId },
      ];
    },
    totalCardInfo() {
      return [
        {
          id: 1,
          label: 'No of events in list:',
          value: this.eventTodos.length,
        },
        {
          id: 2,
          label: 'Sum of revenue in the list:',
          value: `${this.sumOfRevenue()} kr`,
        },
        {
          id: 3,
          label: 'Sum of cost in the list:',
          value: `${this.sumOfCost()} kr`,
        },
      ];
    },
    eventTodos() {
      if (!this._eventTodos || this._eventTodos.length === 0) {
        return [];
      }
      let et = this._eventTodos;

      if (this.searchQuery) {
        const searchLower = this.searchQuery.toLowerCase();
        et = et.filter(todo =>
          Object.values(todo).some(value => {
            return value.toString().toLowerCase() === searchLower;
          })
        );
      }

      for (let f of Object.keys(this.filter)) {
        if (this.filter[f].length > 0) {
          et = et.filter(a => {
            return this.filter[f].includes(a[f]);
          });
        }
      }
      if (this.showShipped) {
        et = et.filter(a => a.isShipped);
      }
      return et.sort((a, b) =>
        this.sortBy in a
          ? this.sortBy in b
            ? a[this.sortBy] > b[this.sortBy]
              ? 1
              : -1
            : 1
          : -1
      );
    },
    eventTodo() {
      return this.$store.getters['todo/costTodo'];
    },
  },
  async mounted() {
    this.isLoading = true;
    if (!this.id && !this.eventTodos.length) {
      await this.$store.dispatch('todo/getCostTodos');
    }
    this.isLoading = false;
  },
  methods: {
    handleTasks(index) {
      this.showEventTodo(this.eventTodos[index].externalId, index);
      if (index < this.eventTodos.length - 1) {
        this.handleTask = true;
      } else {
        this.handleTask = false;
      }
    },
    async setAsDone() {
      this.isLoading = true;
      await this.$store
        .dispatch('todo/patchCostTodo', {
          id: this.eventTodo.externalId,
          status: 'Done',
          comment: this.eventTodo.comment,
        })
        .then(() => {
          if (this.handleTask && this.index < this.eventTodos.length - 1) {
            this.index += 1;
            this.handleTasks(this.index);
          } else {
            this.showNone();
          }
        });
      this.isLoading = false;
    },
    async setAsPause() {
      this.isLoading = true;
      await this.$store
        .dispatch('todo/patchCostTodo', {
          id: this.eventTodo.externalId,
          status: 'Paused',
          comment: this.eventTodo.comment,
        })
        .then(() => {
          if (this.handleTask && this.index < this.eventTodos.length - 1) {
            this.index += 1;
            this.handleTasks(this.index);
          } else {
            this.eventTodo.externalId = false;
          }
        });
      this.isLoading = false;
    },
    async setAsDelete() {
      this.isLoading = true;
      await this.$store
        .dispatch('todo/patchCostTodo', {
          id: this.eventTodo.externalId,
          status: 'Deleted',
          comment: this.eventTodo.comment,
        })
        .then(() => {
          if (this.handleTask && this.index < this.eventTodos.length - 1) {
            this.index += 1;
            this.handleTasks(this.index);
          } else {
            this.eventTodo.externalId = false;
          }
        });
      this.isLoading = false;
    },
    sumOfRevenue() {
      if (this.eventTodos) {
        let myArray = this.eventTodos.map(revenues => revenues.revenue);
        let sumOfArray = myArray.reduce((pv, cv) => pv + cv, 0);
        return sumOfArray.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      }
    },
    sumOfCost() {
      if (this.eventTodos) {
        let myArray = this.eventTodos.map(costs => costs.cost);
        let sumOfArray = myArray.reduce((pv, cv) => pv + cv, 0);
        return sumOfArray.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      }
    },
    showEventTodo(id, index) {
      this.$store.dispatch('todo/getCostTodo', { id: id });
      this.index = index;
    },
    handleEventTodo(id, i) {
      this.$router.push({ name: 'todo-event', params: { id: id } });
    },

    setDisabledDeleteButton() {
      let status = this.eventTodo.status.toLowerCase();
      if (
        status === 'deleted' ||
        status === 'cancelled' ||
        !this.eventTodo.comment
      ) {
        return true;
      }
    },
    setDisabledPauseButton() {
      let status = this.eventTodo.status.toLowerCase();
      if (
        status === 'cancelled' ||
        status === 'paused' ||
        !this.eventTodo.comment
      ) {
        return true;
      }
    },
    setDisabledDoneButton() {
      let status = this.eventTodo.status.toLowerCase();
      if (status === 'done' || status === 'cancelled') {
        return true;
      }
    },
    setDisabledTodoButton() {
      let status = this.eventTodo.status.toLowerCase();
      if (
        status === 'to do' ||
        status === 'cancelled' ||
        !this.eventTodo.comment
      ) {
        return true;
      }
    },
    showNone() {
      this.isLoading = true;
      this.eventTodo.externalId = '';
      this.handleTask = false;
      this.index = 0;
      if (this.id) {
        this.$router.push({ name: 'todo-event' });
      }
      this.isLoading = false;
    },
    filterValues(prop) {
      return [...new Set(this._eventTodos.map(a => a[prop]))]
        .map(a => {
          return {
            displayName: a === '' ? 'None' : a,
            value: a,
            checked: this.filter[prop].includes(a),
          };
        })
        .sort((a, b) => Number(b.value) - Number(a.value));
    },
    filterResults(e, prop) {
      this.filter[prop] = e.options
        .filter(option => option.checked)
        .map(o => o.value);
    },
  },
};
</script>
<style lang="scss" scoped>
.todos_top-container {
  display: flex;
  flex-direction: column;
  width: fit-content;
  gap: 12px;
  margin-bottom: 12px;
  button {
    width: 200px;
  }
  input {
    width: 200px;
  }
  &__showShipped {
    display: flex;
    align-items: center;
    gap: 8px;

    input {
      width: 20px;
      height: 20px;
    }
  }
}

table {
  border-collapse: collapse;
  table-layout: auto;
  width: auto;
  th {
    padding: 0 0.625rem;
    text-align: left;
    background-color: color(blue-light);
  }
  tr {
    &.pointer {
      cursor: auto;
    }
    &:nth-child(even) {
      background-color: color(gray-lighter);
    }
    &.checked {
      background-color: color(blue-light);
    }
  }
  td {
    padding: 0.625rem;
    &:last-child {
      padding-right: 0;
      cursor: pointer;
    }
  }
}
.h1 {
  display: inline-block;
  font-size: font(h1);
  font-weight: bold;
  vertical-align: top;
  margin-top: 20px;
  margin-bottom: 20px;
}
.element--is-loading {
  margin-left: 0.5rem;
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='50px' height='50px' viewBox='0 0 50 50'%3E%3Ccircle fill='none' stroke='%23517FD0' stroke-width='6' stroke-dasharray='45,40' cx='25' cy='25' r='15'/%3E%3CanimateTransform attributeName='transform' dur='1s' type='rotate' from='0 0 0 ' to='360 0 0' repeatCount='indefinite'/%3E%3C/svg%3E");
  background-size: 2rem 2rem;
  background-repeat: no-repeat;
  background-position: center center;
  margin-top: 20px;
}
.ontag {
  flex-grow: 1;
  width: 100%;
  @include media('small') {
    width: calc((100% / 2) - (1rem * 1));
  }
  @include media('large') {
    width: calc((100% / 3) - (1rem * 2));
  }
}
.ontag__content {
  background-color: color(white);
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  padding: 1rem 1.5rem;
  &.dashboard {
    background-color: transparent;
    border-radius: 0;
  }
}
.input-group--inline {
  button {
    margin: 0.5rem;
  }
}
</style>
